export enum InspectionTypeEnum {
    'Self Check' = 1,
    'External Check',
  }
